import {
  SET_PLC_POPUP_STATUS,
  SET_PLC_POPUP_STATUS_SUCCESS,
  SET_PLC_POPUP_STATUS_ERROR,
} from "./actionTypes";

const initialState = {
  errorSetPlcPopupStatus: "",
  loadingSetPlcPopupStatus: false,
  plc_popup_status: null,
  successSetPlcPopupStatus: "",
};

const setPlcPopupStatus = (state = initialState, action) => {
  switch (action.type) {
    case SET_PLC_POPUP_STATUS:
      state = {
        ...state,
        loadingSetPlcPopupStatus: true,
      };
      break;
    case SET_PLC_POPUP_STATUS_SUCCESS:
      state = {
        ...state,
        loadingSetPlcPopupStatus: false,
        plc_popup_status: action.payload.plc_popup_status,
        successSetPlcPopupStatus: action.payload.message,
      };
      break;
    case SET_PLC_POPUP_STATUS_ERROR:
      state = {
        ...state,
        errorSetPlcPopupStatus: action.payload,
        loadingSetPlcPopupStatus: false,
      };
      break;
    default:
      state = { ...state };
      break;
  }
  return state;
};

export default setPlcPopupStatus;
